import { render, staticRenderFns } from "./AppHeaderAddressbook.vue?vue&type=template&id=59af7e6f"
import script from "./AppHeaderAddressbook.vue?vue&type=script&lang=js"
export * from "./AppHeaderAddressbook.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderAddressbook.vue?vue&type=style&index=0&id=59af7e6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports